import { IconInfoCircle } from '@tabler/icons-react';
import type { ReactNode } from 'react';

interface InfoAlertAction {
  label: string;
  onClick: () => void;
}

interface InfoAlertProps {
  title: string;
  message: string;
  icon?: ReactNode;
  action?: InfoAlertAction;
  className?: string;
}

export function InfoAlert({ title, message, icon, action, className }: InfoAlertProps) {
  return (
    <div className={`alert alert-info w-100 ${className ?? 'my-3'}`} role="alert">
      <div className="d-flex justify-content-between align-items-center w-100">
        <div className="d-flex align-items-center">
          <div className="me-3">{icon || <IconInfoCircle size={24} />}</div>
          <div>
            <h4 className="alert-title">{title}</h4>
            <div className="text-secondary">{message}</div>
          </div>
        </div>
        {action && (
          <div className="ms-auto">
            <button type="button" className="btn btn-primary" onClick={action.onClick}>
              {action.label}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
